<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('productPrice.branchName') }}</label>
          <a-select
            v-model="branch_id"
            showSearch
            :max-tag-count="1"
            mode="multiple"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :options="branches"
            class="ts-w-full"
          ></a-select>
          <div class="validate" v-if="errors.has('branch_id')">
            {{ errors.first('branch_id') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label
            for="file"
            class="ts-border ts-p-2 ts-rounded-md ts-cursor-pointer"
            >Browse File</label
          >
          <input
            type="file"
            ref="file"
            id="file"
            class="ts-hidden"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onFileChange"
          />
          <div class="validate" v-if="errors.has('file')">
            {{ errors.first('file') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          {{ display_name }}
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
          <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
          <ts-button color="primary" @click="onImport">{{
            $t('import')
          }}</ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'importFile',
  data () {
    return {
      loading: false,
      display_name: null,
      errors: new Errors(),
      file: undefined,
      branch_id: [],
      branches: []
    }
  },
  created () {
    this.getBranch()
  },
  methods: {
    getBranch () {
      this.$store
        .dispatch('product/price/getBranch')
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .finally(() => {})
    },
    onFileChange (e) {
      this.display_name = null
      this.file = e.target.files[0]
      this.display_name = this.file.name
    },
    onImport () {
      this.loading = true
      this.errors = new Errors()

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('branch_id', this.branch_id)

      this.$store
        .dispatch('product/price/importExcel', formData)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.$refs.file.value = null
      this.file = undefined
    }
  }
}
</script>
